import CropComponent from './crop.vue';

export default {
    install (_Vue) {
        const CropConstructor = _Vue.extend(CropComponent) 
        const instance = new CropConstructor({
            el : document.createElement('div')
        })   
        document.body.appendChild(instance.$el)
        _Vue.prototype.$crop = (base64, fileName, fileSize, cropped, onCrop, cancelCrop) => {
            instance.init(base64, fileName, fileSize, cropped, onCrop, cancelCrop);
        }
        _Vue.prototype.$cancelCrop = () => {
          if (instance.isCrop) {
            instance.cancelCrop()
          }
        }
    }
}



// WEBPACK FOOTER //
// ./src/plugins/crop.js